import React, { useState } from "react";
import LandingPage from "./LandingPage";
import Quiz from "./Quiz";
import Result from "./Result";

import questionsData from "./questions";

function App() {
  const [gameState, setGameState] = useState("start"); // start, quiz, end
  const [selectedCategory, setSelectedCategory] = useState("");
  const [score, setScore] = useState(0);

  const startQuiz = (category) => {
    setSelectedCategory(category);
    setGameState("quiz");
  };

  const endQuiz = (finalScore) => {
    setScore(finalScore);
    setGameState("end");
  };

  const restart = () => {
    setScore(0);
    setSelectedCategory("");
    setGameState("start");
  };

  return (
    <div style={{ fontFamily: "Arial", maxWidth: 600, margin: "auto", padding: 20 }}>
      {gameState === "start" && <LandingPage questions={questionsData} startQuiz={startQuiz} />}
      {gameState === "quiz" && (
        <Quiz
          questions={questionsData.filter(q => q.category === selectedCategory)}
          endQuiz={endQuiz}
        />
      )}
      {gameState === "end" && <Result score={score} total={questionsData.filter(q => q.category === selectedCategory).length} restart={restart} />}
    </div>
  );
}

export default App;
